import { useTrackAnalyticsEvent } from "../analytics/app-insights.hooks";
import { api, ErrorResult, postUrl } from "./base";

const postForm = async (formId: string, data: any, accessToken?: string) => {
  const url = postUrl(formId);
  const headers = accessToken
    ? { "X-Form-AccessToken": accessToken }
    : undefined;

  const result = await api.post(
    url,
    { response: JSON.stringify(data) },
    { headers }
  );
  return result.data;
};

const getForm = async (
  formId: string,
  logEvent: ReturnType<typeof useTrackAnalyticsEvent>,
  pin?: string
): Promise<any> => {
  const handleError = (error: ErrorResult) => {
    if (error.analyticsEvent) {
      logEvent(error.analyticsEvent, {});
    }
    throw error;
  };

  if (pin) {
    return api
      .get<any>(formId, {
        headers: { "X-Form-AccessCode": pin }
      })
      .catch(handleError);
  }
  return api.get<any>(formId).catch(handleError);
};

const getFormFieldData = async (
  formId: string,
  fieldId: string
): Promise<any> => {
  return api.get(`${formId},${fieldId}`);
};

interface DocumentDownloadData {
  blobUrl: string;
  pollPeriodSeconds: number;
  timeOutPeriodSeconds: number;
}

const getDocumentDownloadData = async (
  formId: string,
  accessToken?: string
): Promise<DocumentDownloadData> => {
  const headers = accessToken
    ? { "X-Form-AccessToken": accessToken }
    : undefined;

  const result = await api.post(`${formId}/downloadInfo`, undefined, {
    headers
  });
  return result.data;
};

export { getForm, postForm, getFormFieldData, getDocumentDownloadData };
export type { DocumentDownloadData };
